import { landing as en_landing } from "../en/landing";

/** landing — es slice. */
export const landing: Record<keyof typeof en_landing, string> = {
  // ---- Meta / SEO ----
  landing_meta_home_title: "Linqx — Sin cháchara",
  landing_meta_home_description:
    "Haz match con gente que comparte tu vibra, explora tu ciudad juntos y convierte a desconocidos en historias.",
  landing_meta_root_description:
    "Menos swipe, más vida. Haz match con gente que comparte tu vibra, explora tu ciudad juntos y crea conexiones reales a través de experiencias compartidas.",
  landing_meta_privacy_title: "Linqx — Política de privacidad",
  landing_meta_privacy_description:
    "Descubre cómo Linqx recopila, usa y protege tu información personal.",
  landing_meta_terms_title: "Linqx — Términos de uso",
  landing_meta_terms_description:
    "Lee los términos y condiciones para usar la plataforma y los servicios de Linqx.",
  landing_meta_eula_title:
    "Linqx — Acuerdo de licencia de usuario final (EULA)",
  landing_meta_eula_description:
    "Lee el Acuerdo de licencia de usuario final (EULA) de la aplicación móvil Linqx.",

  // ---- Header / nav ----
  landing_nav_features: "Funciones",
  landing_nav_about: "Nosotros",
  landing_nav_join_waitlist: "Unirte a la lista",
  landing_nav_toggle_menu: "Abrir menú",

  // ---- Hero ----
  landing_hero_eyebrow: "Menos swipe. Más vida.",
  landing_hero_title: "sin cháchara.",
  landing_hero_meet_prefix: "Conoce a gente que ama",
  landing_hero_rotating_adventure: "la aventura",
  landing_hero_rotating_nightlife: "la noche",
  landing_hero_rotating_coffee: "los cafés",
  landing_hero_rotating_events: "los eventos",
  landing_hero_rotating_experiences: "las nuevas experiencias",
  landing_hero_subtitle:
    "Conecta, comparte experiencias en tu ciudad y crea una conexión real con alguien.",
  landing_hero_subtitle_emphasis: "Así de fácil.",
  landing_hero_cta_match: "Hacer match",
  landing_hero_cta_create_profile: "Crear tu perfil",
  landing_hero_hint_mobile: "Desliza las tarjetas 👇 ",
  landing_hero_hint_desktop: "Prueba el mazo — arrastra una tarjeta 👉 ",
  landing_hero_hint_confirm:
    "¿Te gusta a quien conoces? Confirma después de verse en persona.",
  landing_hero_scroll_indicator: "Desliza para explorar",

  // ---- Swipe deck (a11y) ----
  landing_deck_pass_label: "Pasar",
  landing_deck_link_label: "Conectar",
  landing_deck_stamp_link: "LINK",
  landing_deck_stamp_nope: "NOPE",

  // ---- Marquee band ----
  landing_marquee_no_small_talk: "Sin cháchara",
  landing_marquee_real_connections: "Conexiones reales",
  landing_marquee_meet_irl: "En persona",
  landing_marquee_share_the_night: "Comparte la noche",
  landing_marquee_adventure: "Aventura",
  landing_marquee_nightlife: "Vida nocturna",
  landing_marquee_coffee_dates: "Citas de café",
  landing_marquee_live_music: "Música en vivo",
  landing_marquee_city_explorers: "Exploradores urbanos",

  // ---- Features section ----
  landing_features_title_prefix: "Encuentra tu ",
  landing_features_title_highlight: "vibra",
  landing_features_subtitle: "Elige experiencias que van con tu energía.",
  landing_features_vibe_adventure: "Aventura",
  landing_features_vibe_lowkey: "Tranqui",
  landing_features_vibe_outdoor: "Aire libre",
  landing_features_vibe_indoor: "En casa",
  landing_features_vibe_events: "Eventos",
  landing_features_vibe_nightlife: "Vida nocturna",
  landing_features_vibe_foodie: "Foodie",
  landing_features_vibe_coffee: "Café",
  landing_features_vibe_art: "Arte",
  landing_features_vibe_music: "Música",
  landing_features_vibe_sports: "Deportes",
  landing_features_vibe_travel: "Viajes",
  landing_features_card_match_title: "Match auténtico",
  landing_features_card_match_desc:
    "Sin algoritmos, sin juegos. Solo conexiones reales basadas en intereses y experiencias que comparten.",
  landing_features_card_experience_title: "Vivir experiencias juntos",
  landing_features_card_experience_desc:
    "Planea planes, explora tu ciudad y crea recuerdos con alguien nuevo.",
  landing_features_card_build_title: "Crear conexiones",
  landing_features_card_build_desc:
    "Ve más allá de la cháchara y crea relaciones con sentido que duran.",

  // ---- Flow showcase (how it works) ----
  landing_flow_badge: "Cómo funciona",
  landing_flow_title_prefix: "Del hola al aquí, ",
  landing_flow_title_highlight: "un solo flujo",
  landing_flow_subtitle:
    "Recorre la experiencia Linqx — cada toque, swipe y chispa, tal como pasa de verdad.",
  landing_flow_keep_scrolling: "Sigue deslizando",

  landing_flow_discover_eyebrow: "01 — Descubre",
  landing_flow_discover_title: "Encuentra a tu gente",
  landing_flow_discover_desc:
    "Define tu vibra y mira quién está cerca de verdad. Gente real, cerca de ti, con tus mismos gustos.",
  landing_flow_discover_action_vibe: "Elige tu vibra",
  landing_flow_discover_action_nearby: "Mira quién está cerca",
  landing_flow_discover_action_profile: "Tu perfil, listo",

  landing_flow_connect_eyebrow: "02 — Conecta",
  landing_flow_connect_title: "Conócete, luego match",
  landing_flow_connect_desc:
    "Del swipe directo a un plan real. Conócete en persona primero — y haz match solo cuando la chispa es real.",
  landing_flow_connect_action_swipe: "Desliza para conectar",
  landing_flow_connect_action_meet: "Elige un lugar para verse",
  landing_flow_connect_action_match: "¡Es un Linq!",
  landing_flow_connect_action_chat: "Comparte contacto y chatea",

  landing_flow_live_eyebrow: "03 — Vive",
  landing_flow_live_title: "Vive la noche",
  landing_flow_live_desc:
    "Convierte un match en una salida — eventos cerca de ti, check-ins y un poco de competencia sana.",
  landing_flow_live_action_events: "Descubre eventos",
  landing_flow_live_action_checkin: "Haz check-in, gana puntos",
  landing_flow_live_action_leaderboard: "Lidera el ranking",

  // ---- Flow phone screens (in-app demo) ----
  landing_screen_vibes_title: "Tu vibra",
  landing_screen_vibes_subtitle: "¿Qué te gusta?",
  landing_screen_vibes_continue: "Continuar",
  landing_screen_vibe_adventure: "Aventura",
  landing_screen_vibe_nightlife: "Vida nocturna",
  landing_screen_vibe_coffee: "Café",
  landing_screen_vibe_live_music: "Música en vivo",
  landing_screen_vibe_art: "Arte",
  landing_screen_vibe_foodie: "Foodie",

  landing_screen_nearby_title: "Cerca de ti",
  landing_screen_nearby_subtitle: "Gente a tu alrededor ahora mismo",
  landing_screen_nearby_count: "{count} personas",
  landing_screen_nearby_radius: "en {distance}",

  landing_screen_profile_name: "Tú, {age}",
  landing_screen_profile_tag_adventure: "Aventura",
  landing_screen_profile_tag_coffee: "Café",
  landing_screen_profile_tag_live_music: "Música en vivo",
  landing_screen_profile_ready: "Perfil listo",

  landing_screen_swipe_name: "{name}, {age}",
  landing_screen_swipe_distance: "a 1,2 km",
  landing_screen_swipe_tag_coffee: "Café",
  landing_screen_swipe_tag_live_music: "Música en vivo",
  landing_screen_swipe_tag_art: "Arte",

  landing_screen_meet_title: "Elige un lugar para verse",
  landing_screen_meet_subtitle: "Lugares populares cerca",
  landing_screen_meet_suggest: "Sugerir un lugar",
  landing_screen_spot_coffee_name: "Blue Bottle Coffee",
  landing_screen_spot_coffee_meta: "Café · 0,8 km",
  landing_screen_spot_bar_name: "The Rooftop Bar",
  landing_screen_spot_bar_meta: "Copas · 1,4 km",
  landing_screen_spot_park_name: "Riverside Park",
  landing_screen_spot_park_meta: "Aire libre · 2,1 km",

  landing_screen_match_title: "¡Es un Linq!",
  landing_screen_match_pair: "Tú y {name}",
  landing_screen_match_met_irl: "Se conocieron en persona ✨",

  landing_screen_chat_contact_shared: "Contacto compartido",
  landing_screen_chat_msg_1: "¡Ey! La pasamos genial 👋",
  landing_screen_chat_msg_2: "¡Igual! ¿La semana que viene a la misma hora?",
  landing_screen_chat_msg_3: "Es una cita 💫",
  landing_screen_chat_placeholder: "Mensaje…",

  landing_screen_events_title: "Esta noche cerca de ti",
  landing_screen_events_subtitle: "Eventos que le gustan a tus matches",
  landing_screen_event_location: "Centro · 1,1 km",
  landing_screen_event_rooftop_name: "Rooftop Social",
  landing_screen_event_rooftop_meta: "Sáb · 21:00",
  landing_screen_event_rooftop_tag: "Voy",
  landing_screen_event_vinyl_name: "Vinyl & Wine",
  landing_screen_event_vinyl_meta: "Vie · 20:00",
  landing_screen_event_vinyl_tag: "+24 van",

  landing_screen_checkin_title: "Rooftop Social",
  landing_screen_checkin_subtitle: "Ya llegaste — haz check-in",
  landing_screen_checkin_scan: "Escanea para conectar",
  landing_screen_checkin_button: "Check-in",
  landing_screen_checkin_points: "+50 CP",
  landing_screen_checkin_countdown: "El Speed Linq empieza en 5:00",

  landing_screen_leaderboard_title: "Top Mixers",
  landing_screen_leaderboard_subtitle: "Rooftop Social · esta noche",
  landing_screen_leaderboard_you: "Tú",
  landing_screen_leaderboard_footer: "Vas #2 — ¡sigue conectando!",

  // ---- Stats section ----
  landing_stats_title_prefix: "Menos app. ",
  landing_stats_title_highlight: "Más tú.",
  landing_stats_subtitle:
    "Linqx está hecho para sacarte de la pantalla y meterte en el momento.",
  landing_stats_small_talk_label: "Frases de cháchara",
  landing_stats_irl_label: "Se conocen en persona primero",
  landing_stats_steps_suffix: " pasos",
  landing_stats_steps_label: "Del swipe a un plan real",
  landing_stats_vibes_label: "Vibras que van con tu energía",

  // ---- CTA section ----
  landing_cta_title_prefix: "Donde las conexiones ",
  landing_cta_title_highlight: "cobran vida",
  landing_cta_subtitle:
    "Haz match con alguien nuevo y comparte una experiencia inolvidable juntos. De eventos exclusivos a noches épicas — convierte a desconocidos en historias.",
  landing_cta_pillar_swipe: "Swipe",
  landing_cta_pillar_link: "Conecta",
  landing_cta_pillar_live: "Vive",
  landing_cta_button: "Unirte a la lista",

  // ---- Waitlist form ----
  landing_waitlist_badge: "Acceso anticipado limitado",
  landing_waitlist_title_prefix: "Sé parte de algo ",
  landing_waitlist_title_highlight: "especial",
  landing_waitlist_subtitle: "Match. Experiencia. Conexión.",
  landing_waitlist_name_placeholder: "Tu nombre (opcional)",
  landing_waitlist_email_placeholder: "Escribe tu email",
  landing_waitlist_submit: "Unirte a la lista",
  landing_waitlist_disclaimer:
    "Nada de spam. Solo te avisamos cuando lancemos.",
  landing_waitlist_success_title: "¡Estás dentro!",
  landing_waitlist_success_subtitle: "Bienvenido a la lista de espera",
  landing_waitlist_success_note: "Te avisaremos cuando lancemos.",
  landing_waitlist_error_email_required: "Escribe tu dirección de email",
  landing_waitlist_error_email_invalid: "Escribe una dirección de email válida",
  landing_waitlist_error_generic: "Algo salió mal. Inténtalo de nuevo.",

  // ---- Footer ----
  landing_footer_tagline:
    "Sin cháchara. Solo conexiones reales a través de experiencias compartidas.",
  landing_footer_rights: "© {year} Linqx. Todos los derechos reservados.",
  landing_footer_col_company: "Empresa",
  landing_footer_col_legal: "Legal",
  landing_footer_col_get_app: "Descarga la app",
  landing_footer_link_about: "Nosotros",
  landing_footer_link_features: "Funciones",
  landing_footer_link_contact: "Contacto",
  landing_footer_link_privacy: "Política de privacidad",
  landing_footer_link_terms: "Términos del servicio",
  landing_footer_link_eula: "EULA",
  landing_footer_social_x: "X",
  landing_footer_social_instagram: "Instagram",
  landing_footer_social_tiktok: "TikTok",
  landing_footer_social_email: "Email",
  landing_footer_coming_soon: "Pronto en",
  landing_footer_app_store: "App Store",
  landing_footer_google_play: "Google Play",

  // ---- Legal layout chrome ----
  landing_legal_back_home: "Volver al inicio",
  landing_legal_last_updated: "Última actualización: {date}",
  landing_legal_privacy_title: "Política de privacidad",
  landing_legal_terms_title: "Términos de uso",
  landing_legal_eula_title:
    "Acuerdo de licencia de usuario final (EULA) de Linqx",
  landing_legal_privacy_updated: "1 de febrero de 2025",
  landing_legal_terms_updated: "6 de febrero de 2025",
  landing_legal_eula_updated: "4 de marzo de 2025",
};
